import { Icon } from "../../../../components";

interface MetricPillProps {
  value: number | string;
  label?: string;
  variant: "success" | "warning" | "danger" | "secondary";
  icon: string;
  isEmpty?: boolean;
}

export function MetricPill({
  value,
  label,
  variant,
  icon,
  isEmpty = false,
}: MetricPillProps) {
  const activeVariant = isEmpty ? "secondary" : variant;
  return (
    <div
      className={`d-flex align-items-center gap-2 flex-fill px-3 py-2 rounded border bg-${activeVariant}-subtle border-${activeVariant}`}
    >
      <Icon
        iconName={icon}
        className={`text-${activeVariant}`}
        style={{ fontSize: "0.75rem", flexShrink: 0 }}
      />
      <div>
        <div
          className={`fw-bold lh-1 mb-1 text-${activeVariant}`}
          style={{ fontSize: "1.125rem" }}
        >
          {value}
          <span
            style={{ fontSize: "0.625rem", fontWeight: 600, marginLeft: 1 }}
          >
            %
          </span>
        </div>
        <div
          className={`text-uppercase fw-semibold text-${activeVariant}`}
          style={{ fontSize: "0.6rem", letterSpacing: "0.08em" }}
        >
          {label}
        </div>
      </div>
    </div>
  );
}
